/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var L;!function(L){L[L.NONE=0]="NONE",L[L.TILT=1]="TILT",L[L.ALTITUDE=2]="ALTITUDE",L[L.DISTANCE=4]="DISTANCE",L[L.COLLISION=8]="COLLISION",L[L.ALL=15]="ALL",L[L.ALL_EXCEPT_COLLISION=7]="ALL_EXCEPT_COLLISION"}(L||(L={}));export{L as ConstraintTypes};
